import { styled } from "@mui/material";
import { editorToolbarName } from "../classes.js";
const Divider = styled("div", {
  name: editorToolbarName,
  slot: "Divider",
  overridesResolver: (_props, styles) => styles.divider
})(({ theme }) => ({
  "&:after": {
    margin: theme.spacing(0, 0.5),
    content: '""',
    fontSize: "1.5rem",
    borderRight: `1px solid ${(theme.vars ?? theme).palette.divider}`
  }
}));
export {
  Divider
};
//# sourceMappingURL=Divider.js.map
